export const PLAN_SYNC = 'sync'
export const PLAN_DEACTIVATED = 'deactivated'

export type AccountPlan = typeof PLAN_SYNC | typeof PLAN_DEACTIVATED
export type AccountAccessState = 'none' | 'sync' | 'deactivated'

export function hasSyncAccessFromPlan(plan: string | null | undefined): boolean {
  return plan === PLAN_SYNC
}

export function isKnownAccountPlan(plan: string | null | undefined): plan is AccountPlan {
  return plan === PLAN_SYNC || plan === PLAN_DEACTIVATED
}

export function resolveAccountAccessState(plan: string | null | undefined): AccountAccessState {
  if (plan === PLAN_SYNC) return 'sync'
  if (plan === PLAN_DEACTIVATED) return 'deactivated'
  return 'none'
}
